import React from "react";
import "./Intro.css";
import avatar from "../../img/myAvatar.png"
import Github from "@iconscout/react-unicons/icons/uil-github";
import LinkedIn from "@iconscout/react-unicons/icons/uil-linkedin";
import Instagram from "@iconscout/react-unicons/icons/uil-instagram";
import Twitter from "@iconscout/react-unicons/icons/uil-twitter"
import { motion } from "framer-motion";
import { Link } from "react-scroll";
import Counter from "../Counter/Counter";
const Intro = () => {
  return (
    <section className="Intro" id="Intro">
      <motion.div
        className="i-left"
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.55 }}
      >
        <div className="i-name">
          <span className="i-eyebrow">Full-stack developer</span>
          <h1>Sicelo Sitsha</h1>
          <span>
            I build complete web products from interface to API: polished React
            frontends, reliable Node backends, and practical product workflows
            that stay easy to maintain.
          </span>
        </div>
        <div className="i-actions">
          <Link to="portfolio" smooth={true} spy={true}>
            <button className="button i-button">View work</button>
          </Link>
          <Link to="contact" smooth={true} spy={true}>
            <button className="button button-secondary">Start a project</button>
          </Link>
        </div>
        <div className="i-icons">
          <a href="https://github.com/sicelo17/" aria-label="GitHub">
            <Github color="currentColor" size={"1.55rem"} />
          </a>
          <a href="https://www.linkedin.com/in/sicelositsha/" aria-label="LinkedIn">
            <LinkedIn color="currentColor" size={"1.55rem"} />
          </a>
          <a href="https://www.instagram.com/i.am.sicelo/" aria-label="Instagram">
            <Instagram color="currentColor" size={"1.55rem"} />
          </a>
          <a href="https://twitter.com/sitsha_sicelo" aria-label="Twitter">
            <Twitter color="currentColor" size={"2rem"}/>
          </a>
        </div>
      </motion.div>
      <div className="i-right">
        <motion.div
          className="i-portrait"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          <img src={avatar} alt="Sicelo Sitsha" className="main__image"/>
          <div className="i-signal i-signal-top">
            <Counter end={5} />
            <span>years experience</span>
          </div>
          <div className="i-signal i-signal-bottom">
            <Counter end={10} />
            <span>products shipped</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Intro;
